import { Outlet, useOutletContext } from 'react-router-dom'

import { WorkScheduleEmployeePageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import WorkScheduleEmployees from 'modules/work_schedules/components/WorkScheduleEmployees'
import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'
import { RedirectToWorkScheduleListPage } from 'modules/work_schedules/pages/settings/RedirectToWorkScheduleListPage'
import schedules from 'modules/work_schedules/store/collections/schedules'

const WorkScheduleEmployeePage = () => {
  const { workSchedule, defaultPeriod } = useOutletContext<RouteContextParams>()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading: loadingGraphql } = useQuery(WorkScheduleEmployeePageDocument, {
    variables: {
      scheduleId: workSchedule?.id,
      companyId,
    },
  })
  const { loading } = useAsyncData(() => Promise.all([schedules.fetch()]), [])

  const canAssignEmployees = data?.workSchedule.schedule?.canAssignEmployeesPolicy.can ?? false
  const hasFixedWorkSchedulesEnabled = data?.features.featuresConnection.nodes[0]?.enabled ?? false

  if (loading || loadingGraphql) {
    return <Loading />
  }

  if (!hasFixedWorkSchedulesEnabled && defaultPeriod?.isFixed) {
    return <RedirectToWorkScheduleListPage />
  }

  return workSchedule ? (
    <AuthorizeUser authorizeFn={() => canAssignEmployees}>
      <WorkScheduleEmployees
        loading={loading}
        workSchedule={workSchedule}
        canAssignEmployees={canAssignEmployees}
      >
        <Outlet />
      </WorkScheduleEmployees>
    </AuthorizeUser>
  ) : null
}

export default WorkScheduleEmployeePage
